function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */
import PropTypes from 'prop-types';
import React from 'react';
import { useAppState } from '@components/common/context/app';
function Area(props) {
  var context = useAppState();
  var {
    id,
    coreComponents,
    wrapperProps,
    noOuter,
    wrapper,
    className,
    components
  } = props;
  var areaComponents = (() => {
    var areaCoreComponents = coreComponents || [];
    var widgets = context.widgets || [];
    var wildCardWidgets = components['*'] || {};
    var assignedWidgets = [];
    widgets.forEach(widget => {
      var w = wildCardWidgets[widget.type];
      if (widget.areaId.includes(id) && w !== undefined) {
        assignedWidgets.push({
          id: widget.id,
          sortOrder: widget.sortOrder,
          props: widget.props,
          component: w.component
        });
      }
    });
    var cs = components[id] === undefined ? areaCoreComponents.concat(assignedWidgets) : areaCoreComponents.concat(Object.values(components[id])).concat(assignedWidgets);
    return cs.sort((obj1, obj2) => obj1.sortOrder - obj2.sortOrder);
  })();
  var {
    propsMap
  } = context;
  var WrapperComponent = React.Fragment;
  if (noOuter !== true) {
    if (wrapper !== undefined) {
      WrapperComponent = wrapper;
    } else {
      WrapperComponent = 'div';
    }
  }
  var areaWrapperProps = {};
  if (noOuter === true) {
    areaWrapperProps = {};
  } else if (typeof wrapperProps === 'object' && wrapperProps !== null) {
    areaWrapperProps = _objectSpread({
      className: className || ''
    }, wrapperProps);
  } else {
    areaWrapperProps = {
      className: className || ''
    };
  }
  return /*#__PURE__*/React.createElement(WrapperComponent, areaWrapperProps, areaComponents.map((w, index) => {
    var C = w.component.default;
    // eslint-disable-next-line no-shadow
    var {
      id
    } = w;
    var propsData = context.graphqlResponse;
    var propKeys = propsMap[id] || [];
    var componentProps = propKeys.reduce((acc, map) => {
      var {
        origin,
        alias
      } = map;
      acc[origin] = propsData[alias];
      return acc;
    }, {});
    if (w.props) {
      Object.assign(componentProps, w.props);
    }
    // Check if C is a React component
    if (/*#__PURE__*/React.isValidElement(C)) {
      return C;
    }
    if (typeof C === 'string') {
      // eslint-disable-next-line react/no-array-index-key
      return /*#__PURE__*/React.createElement(C, _extends({
        key: index
      }, componentProps));
    }

    // eslint-disable-next-line react/no-array-index-key
    return /*#__PURE__*/React.createElement(C, _extends({
      key: index,
      areaProps: props
    }, componentProps));
  }));
}
Area.propTypes = {
  className: PropTypes.string,
  coreComponents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    sortOrder: PropTypes.number,
    component: PropTypes.shape({
      default: PropTypes.elementType
    })
  })),
  id: PropTypes.string.isRequired,
  noOuter: PropTypes.bool,
  wrapper: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  // eslint-disable-next-line react/forbid-prop-types
  wrapperProps: PropTypes.object,
  components: PropTypes.shape({
    '*': PropTypes.objectOf(PropTypes.shape({
      component: PropTypes.shape({
        default: PropTypes.elementType
      })
    }))
  }).isRequired
};
Area.defaultProps = {
  className: undefined,
  coreComponents: [],
  noOuter: false,
  wrapper: 'div',
  wrapperProps: {}
};
export default Area;